import axios from "axios";
import { toastr } from "react-redux-toastr";
import {
  FETCH_MOBILE_APP,
  FETCH_FAKE_SOCIAL_MEDIA,
  FETCH_FAKE_SOCIAL_MEDIA_TOTAL,
  FETCH_DARK_WEB_MENTION,
  FETCH_WEB_DEFACEMENT,
  FETCH_MOBILE_APP_TOTAL,
  FETCH_MOBILE_APP_EXCEL,
  FETCH_FAKE_SOCIAL_MEDIA_EXCEL,
  SUSPICIOUS_CLOUD_TOTAL,
  SUSPICIOUS_CLOUD_GRAPH,
  FETCH_MOBILE_SOURCE
} from ".";
import { API_URL } from "../utils/constant";



export const fetchMobileApp = (props, dispatch, page, type, category, startDate, endDate, limit, search, domain) => {
  if (props) {
    axios
      .get(`${API_URL}/get-appsv2/${props}/delta?page=${page}&limit=${limit}&type=${type}&category=${category}&from=${startDate}&till=${endDate}&search=${search}&domain=${domain || ''}`)
      .then((res) => {
        dispatch({
          type: FETCH_MOBILE_APP,
          mobileData: res.data,
        });
      });
  }
};

export const addMobileApp = (props, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/createAppStore`, props)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const mobileSource = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/get-appsv2/${props}/sources`)
      .then((res) => {
        dispatch({
          type: FETCH_MOBILE_SOURCE,
          mobileData: res.data,
        });
      });
  }
};

export const fetchMobileAppUpdate = (props, dispatch, data, clear, pageMob) => {
  if (props) {
    axios
      .patch(`${API_URL}/get-appsv2/${props}/update`, data)
      .then((res) => {
        dispatch({
          type: FETCH_MOBILE_APP,
          mobileData: res.data,
        });
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          clear()
          fetchMobileApp(props, dispatch, pageMob, '', 'all', '', '', 10, '')
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchMobileAppDelete = (orgId, props, dispatch) => {
  if (props) {
    axios
      .delete(`${API_URL}/get-appsv2/${orgId}/${props}/delete`)
      .then((res) => {
        dispatch({
          type: FETCH_MOBILE_APP,
          mobileData: res.data,
        });
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          fetchMobileApp(orgId, dispatch, 1, '', 'all', '', '', 10, '')
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchMobileRemidiatedFalseTrue = (props, dispatch, data, page, type, category, domain) => {
  if (props) {
    axios
      .post(`${API_URL}/get-appsv2/${props}/action?page=${page}&type=${type}&category=${category}&domain=${domain || ''}`, data)
      .then((res) => {
        dispatch({
          type: FETCH_MOBILE_APP,
          mobileData: res.data,
        });
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchSocailRemidiatedFalseTrue = (props, dispatch, data, page, category, type, platform, verified, startDate, endDate, search, pageSize, domain) => {
  if (props) {
    axios
      .post(`${API_URL}/getFakeSocialMediav2/${props}/action?page=${page}&category=${category}&type=${type}&platform=${platform}&status=${verified}&from=${startDate}&till=${endDate}&search=${search}&domain=${domain || ''}`, data)
      .then((res) => {
        dispatch({
          type: "FETCH_FAKE_SOCIAL_MEDIA",
          mobileData: res.data,
        });
        if (res.data.status == 200) {
          fetchFakeSocialMedia(props, dispatch, page, category, platform, verified, startDate, endDate, pageSize, search, domain);
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchMobileTotal = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/get-appsv2/${props}/totals`)
      .then((res) => {
        dispatch({
          type: FETCH_MOBILE_APP_TOTAL,
          mobileData: res.data,
        });
      });
  }
};

export const fetchScanDetail = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/get-appsv2/${props}/graph`)
      .then((res) => {
        dispatch({
          type: FETCH_MOBILE_APP_EXCEL,
          mobileData: res.data,
        });
      });
  }
};

export const fetchDarkWebMention = (props, dispatch) => {
  axios
    .get(`${API_URL}/getDarkWebMentions`, {
      params: {
        orgId: props,
      },
    })
    .then((res) => {
      dispatch({
        type: FETCH_DARK_WEB_MENTION,
        data: res.data.data,
      });
    });
};


export const fetchFakeSocialMediaGraph = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/getFakeSocialMediav2/${props}/graph`)
      .then((res) => {
        dispatch({
          type: FETCH_FAKE_SOCIAL_MEDIA_EXCEL,
          mobileData: res.data,
        });
      });
  }
};

export const fetchFakeSocialMedia = (props, dispatch, page, category, platform, verified, startDate, endDate, limit, search, domain) => {
  if (props) {
    axios
      .get(`${API_URL}/getFakeSocialMediav2/${props}/delta?page=${page}&limit=${limit}&category=${category}&platform=${platform}&status=${verified}&from=${startDate}&till=${endDate}&search=${search}&domain=${domain || ''}`)
      .then((res) => {
        dispatch({
          type: "FETCH_FAKE_SOCIAL_MEDIA",
          mobileData: res.data,
        });
      });
  }
};

export const fetchFakeSocialMediaUpdate = (props, dispatch, data, clear, p) => {
  if (props) {
    axios
      .patch(`${API_URL}/getFakeSocialMediav2/${props}/update`, data)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          clear()
          fetchFakeSocialMedia(props, dispatch, p, 'all', 'all', '', '', 10, '', '', '');
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchFakeSocialMediaDelete = (props, id, dispatch, p) => {
  if (props) {
    axios
      .delete(`${API_URL}/getFakeSocialMediav2/${props}/${id}/delete`)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          fetchFakeSocialMedia(props, dispatch, p, 'all', 'all', '', '', 10, '', '', '');
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};


export const fetchFakeSocialMediaTotal = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/getFakeSocialMediav2/${props}/totals`)
      .then((res) => {
        dispatch({
          type: FETCH_FAKE_SOCIAL_MEDIA_TOTAL,
          fakeSocialCount: res.data,
        });
      });
  }
};


export const getAppById = (props, dispatch) => {
  axios
    .get(`${API_URL}/getApp`, {
      params: {
        customerId: props.customerId,
        appId: props.appId,
      },
    })
    .then((res) => {
      dispatch({
        type: "FETCHED_MOBILE_DATA",
        fetchedMobileData: res.data,
      });

      toastr.success("Success", "App fetched Successfully");
    })
    .catch((err) => {
      toastr.err("Error", "App Had an issue while fetching!");
    });
};

export const markAsSuspicious = (
  _id,
  _isSuspicious,
  _isBlacklist,
  _isLinkDown,
  _action,
  _orgId,
  dispatch
) => {
  axios
    .patch(`${API_URL}/updateApp`, {
      id: _id,
      isSuspicious: _isSuspicious,
      isBlacklist: _isBlacklist,
      isLinkDown: _isLinkDown,
      organisationId: _orgId
    })
    .then((res) => {
      if (!res.data.error) {
        // toastr.success("SUCCESS", "Marked as Suspicious");
        if (_action == "Suspicious") {
          toastr.success(
            "SUCCESS",
            `${_isSuspicious ? "Marked as Suspicious" : "Removed from Suspicious"}`
          );
        } else if (_action == "Blacklist") {
          toastr.success(
            "SUCCESS",
            `${_isBlacklist ? "Marked as Blacklist" : "Removed from Blacklist"}`
          );
        } else {
          toastr.success(
            "SUCCESS",
            `${_isLinkDown ? "Marked as Linkdown" : "Removed from Linkdown"}`
          );
        }
        dispatch({
          type: FETCH_MOBILE_APP,
          mobileData: res.data,
        });
      } else {
        toastr.error("ERROR", "SOMETHING WENT WRONG!");
      }
    })
    .catch((err) => {
      toastr.error("ERROR", "SOMETHING WENT WRONG!");
    });
};

export const getOpenCloudData = (keyword, orgId, dispatch) => {
  if (keyword && orgId) {
    axios
      .get(`${API_URL}/cloud-bucket`, {
        params: {
          orgId: orgId,
        },
      })
      .then((res) => {
        dispatch({
          type: "SET_OPEN_CLOUD",
          data: res.data.data,
        });
      });
  }
};

export const getAllCloudRepo = (keyword, orgId, dispatch) => {
  if (keyword && orgId) {
    axios
      .get(`${API_URL}/open-cloud`, {
        params: {
          keyword: keyword,
          orgId: orgId,
        },
      })
      .then((res) => {
        dispatch({
          type: "SET_OPEN_CLOUD_ALL",
          data: res.data.data,
        });
      });
  }
};

export const updateStatus = (
  _id,
  _isSuspicious,
  _isBlacklisted,
  _keyword,
  dispatch
) => {
  axios
    .patch(`${API_URL}/open-cloud`, {
      id: _id,
      isSuspicious: _isSuspicious,
      isBlacklisted: _isBlacklisted,
      keyword: _keyword,
    })
    .then((res) => {
      if (!res.data.error) {
        toastr.success(
          "SUCCESS",
          `${_isSuspicious ? "Marked as Suspicious" : "Marked as Blacklisted"}`
        );
        if (_isBlacklisted) {
          dispatch({
            type: "SET_OPEN_CLOUD",
            data: res.data.data,
          });
        }
      } else {
        toastr.error("ERROR", "SOMETHING WENT WRONG!");
      }
    })
    .catch((err) => {
      toastr.error("ERROR", "SOMETHING WENT WRONG!");
    });
};

export const getSuspicousCloudData = (orgId, dispatch, page, category, type, startDate, endDate, limit, search, keyword, fileType = 'all') => {
  if (orgId) {
    let url = `${API_URL}/cloud-bucket-details/${orgId}/delta?page=${page}&limit=${limit}&category=${category}&type=${type}&from=${startDate}&till=${endDate}&search=${search}`;
    if (keyword && keyword !== 'all') {
      url += `&keyword=${keyword}`;
    }
    if (fileType && fileType !== 'all') {
      url += `&fileType=${fileType}`;
    }
    axios
      .get(url)
      .then((res) => {
        dispatch({
          type: "SET_SUSPICIOUS_CLOUD",
          data: res.data,
        });
      });
  }
};

export const cloudUpdateById = (orgId, dispatch, data, clear) => {
  if (orgId) {
    axios
      .patch(`${API_URL}/cloud-bucket-details/${orgId}/update`, data)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          getSuspicousCloudData(orgId, dispatch, 1, 'all', '', '', '', 10, '', 'all', 'all');
          clear();
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const cloudBucketDeleteById = (orgId, id, dispatch) => {
  if (orgId) {
    axios
      .delete(`${API_URL}/cloud-bucket-details/${orgId}/${id}/delete`,)
      .then((res) => {
        if (res.data.status == 200) {
          getSuspicousCloudData(orgId, dispatch, 1, 'all', '', '', '', 10, '', 'all', 'all')
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const uploadexcelCloud = (props, id, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios.post(`${API_URL}/cloud-bucket-details/upload-excel`, props)
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        toastr.success("Success", response.data.userMessage);
      // dispatch({
      //   type: "SET_SUSPICIOUS_CLOUD",
      //   data: response.data,
      // });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
    });
};



export const getSuspicousCloudAction = (orgId, dispatch, page, category, type, data, limit, startDate = '', endDate = '', search = '', keyword = 'all', fileType = 'all') => {
  if (orgId) {
    let url = `${API_URL}/cloud-bucket-details/${orgId}/action?page=${page}&limit=${limit}&category=${category}&type=${type}&from=${startDate}&till=${endDate}&search=${search}`;
    if (keyword && keyword !== 'all') {
      url += `&keyword=${keyword}`;
    }
    if (fileType && fileType !== 'all') {
      url += `&fileType=${fileType}`;
    }
    axios
      .post(url, data)
      .then((res) => {
        dispatch({
          type: "SET_SUSPICIOUS_CLOUD",
          data: res.data,
        });
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.error("Error", res.data.userMessage);
        }
      });
  }
};

export const getSuspicousCloudTotal = (orgId, dispatch) => {
  if (orgId) {
    axios
      .get(`${API_URL}/cloud-bucket-details/${orgId}/totals`,)
      .then((res) => {
        dispatch({
          type: SUSPICIOUS_CLOUD_TOTAL,
          data: res.data,
        });
      });
  }
};

export const getSuspicousCloudGraph = (orgId, dispatch) => {
  if (orgId) {
    axios
      .get(`${API_URL}/cloud-bucket-details/${orgId}/graph`,)
      .then((res) => {
        dispatch({
          type: SUSPICIOUS_CLOUD_GRAPH,
          data: res.data,
        });
      });
  }
};

export const markSuspicious = (
  _id,
  _isSuspicious,
  _isBlacklist,
  _isLinkDown,
  _type,
  _action,
  _orgId,
  dispatch
) => {
  let url = '';

  if (_type == "sourceCode") url = `${API_URL}/updateSourceCode`;
  else if (_type == "darkWeb") url = `${API_URL}/updateDarkWeb`;
  else if (_type == "socialMedia") url = `${API_URL}/updateFakeSocial`;

  axios
    .patch(url, {
      id: _id,
      isSuspicious: _isSuspicious,
      isBlacklist: _isBlacklist,
      isLinkDown: _isLinkDown,
      organisationId: _orgId
    })
    .then((res) => {
      if (!res.data.error) {
        if (_action == "Suspicious") {
          toastr.success(
            "SUCCESS",
            `${_isSuspicious ? "Marked as Suspicious" : "Removed from Suspicious"}`
          );
        } else if (_action == "Blacklist") {
          toastr.success(
            "SUCCESS",
            `${_isBlacklist ? "Marked as Blacklist" : "Removed from Blacklist"}`
          );
        } else {
          toastr.success(
            "SUCCESS",
            `${_isLinkDown ? "Marked as Linkdown" : "Removed from Linkdown"}`
          );
        }
        if (_type == "sourceCode") {
          dispatch({
            type: "SET_LEAKED_CODE",
            data: res.data,
          });
        } else if (_type == "darkWeb") {
          dispatch({
            type: FETCH_DARK_WEB_MENTION,
            data: res.data.data,
          });
        } else {
          dispatch({
            type: FETCH_FAKE_SOCIAL_MEDIA,
            mobileData: res.data,
          });
        }
      } else {
        toastr.error("ERROR", "SOMETHING WENT WRONG!");
      }
    })
    .catch((err) => {
      toastr.error("ERROR", "SOMETHING WENT WRONG!");
    });
};

export const webDefacement = (orgId, dispatch) => {
  if (orgId) {
    axios
      .get(`https://api.brandsek.com/api/report/website_defacement?organisationId=${orgId}&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImFkbWluQGJyYW5kc2VrLmNvbSIsInVzZXJJZCI6IjYxZWE2YWUwM2E2NjhjM2UzYTk4NmY2ZCIsImlhdCI6MTY2MjMwNDA3NywiZXhwIjoxNjYyMzExMjc3fQ.24guuW48l9hLsHmwYaLsBuLJW2gc3kpIobTIWPLxMkk`)
      .then((res) => {
        dispatch({
          type: FETCH_WEB_DEFACEMENT,
          data: res?.data?.data?.data?.website_defacement_report?.[0]?.links,
        });
      });
  }
}